import { Button, Card, Col, Input, Row, Timeline } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { GlobalUtil } from "../../utils/GlobalText"
import { StyleUtils } from "../../utils/Style"
import { UserInfoManager } from "../../utils/UserInfoManager"
import { AntdButton, AntdCard, AppButton, AppMainText } from "../../views/commonview"
import { ChangeEvent, useEffect, useState } from "react"
import { deepCopy } from "../../utils/deepCopy"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import events from "../../utils/events"
import { AppEvent } from "../../data/events"
import { GITHUB_LINKS, getCoinConfig } from "../../utils/CoinConfig"

interface SecurityData {
    title: string | undefined
    value: string | undefined
}
interface InfoItemViewProp {
    title?: string
    text?: string,
    leftSpan?: number,
    rightSpan?: number,
    isCopy?: boolean;
    onChange?: (value: string, title?: string) => void
}

const InfoItemView: React.FC<InfoItemViewProp> = (props) => {
    const handleInputChange = (value: string) => {
        props.onChange && props.onChange(value, props.title)
    }
    return <Row style={{ background: StyleUtils.theme().home_guide_item_color_1, border: "solid", borderColor: StyleUtils.theme().home_guide_item_color_1, borderWidth: "0.5px", width: "100%", display: "flex", flexFlow: "row nowrap", borderRadius: "8px", overflow: "hidden" }}>
        <Col span={props.leftSpan ?? 8} style={{ display: "flex", whiteSpace: "nowrap", alignItems: "center", justifyContent: "center", color: StyleUtils.theme().fontColor_1, fontSize: "0.88rem", fontWeight: "500", borderRadius: "8px 0px 0px 8px", background: StyleUtils.theme().home_guide_item_color_1, height: "100%", padding: '4px 12px', maxWidth: "180px" }}>
            {props.title}
        </Col>
        <Input
            className="example-input"
            style={{
                ...StyleUtils.textWrap(),
                color: StyleUtils.theme().fontColor_1,
            }} value={props?.text} onChange={(evt) => {
                handleInputChange(evt.target.value);
            }} />
    </Row>
}

export const HomeGuideView = () => {
    const { xs } = useBreakpoint()
    const [expInputs, setExpInputs] = useState<SecurityData[]>([
        {
            "title": GlobalUtil.t("home_guide.account_name"),
            "value": UserInfoManager.currentAccount,
        },
        {
            "title": GlobalUtil.t("home_guide.worker_name"),
            "value": "miner1",
        },
        {
            "title": GlobalUtil.t("home_guide.pool_address"),
            "value": `stratum+tcp://${UserInfoManager.currency}.drpool.io:${getCoinConfig(UserInfoManager.currency).port}`,
        }
    ]);
    const Items2: SecurityData[] = [
        {
            "title": "Miner",
            "value": `./${getCoinConfig(UserInfoManager.currency).prover} -w ${expInputs[0].value || "default"}.${expInputs[1].value || "miner"} -p ${expInputs[2].value} `,
        }
    ]
    const handleExpInputs = (value: string, title?: string) => {
        const findIndex = expInputs.findIndex((item) => item.title === title);
        if (findIndex !== -1) {
            const expDup = deepCopy(expInputs);
            expDup[findIndex].value = value;
            expDup[2].value = `stratum+tcp://${UserInfoManager.getCurrency()}.drpool.io:${getCoinConfig(UserInfoManager.currency).port}`;
            setExpInputs(expDup);
        }
    }

    events.on(AppEvent.REFRES, ({ currency, language, account }: any) => {
        if (currency || account) {
            handleExpInputs(UserInfoManager.currentAccount, GlobalUtil.t("home_guide.account_name"))
        }
    })
    useEffect(() => {
        const transExp = [
            {
                "title": GlobalUtil.t("home_guide.account_name"),
                "value": expInputs[0].value,
            },
            {
                "title": GlobalUtil.t("home_guide.worker_name"),
                "value": expInputs[1].value,
            },
            {
                "title": GlobalUtil.t("home_guide.pool_address"),
                "value": expInputs[2].value,
            }
        ]
        setExpInputs(transExp);
    }, [GlobalUtil.globalT])

    return <div id="startMning">
        <Row justify={"center"} style={{ color: StyleUtils.theme().fontColor_1, fontSize: "2.4rem", alignItems: "center", marginTop: StyleUtils.getWidth(36), marginBottom: StyleUtils.getWidth(18) }}>

            <div style={{ fontWeight: "500" }}>
                {GlobalUtil.t("home.startMining")}
            </div>
            <div style={{ width: StyleUtils.getWidth(3) }} />
            <AppMainText text={UserInfoManager.getShowCurrency()} />
            <div style={{ width: StyleUtils.getWidth(3) }} />
            <div style={{ fontWeight: "500" }}>
                {GlobalUtil.t("home.startMiningHomeNow")}
            </div>

        </Row>
        <Timeline
            className="tml"
            items={[
//                 {
//                     children: <AntdCard><Card>
//                         <div style={{ ...StyleUtils.fontStyle_2(), fontSize: StyleUtils.getFont(14) }}>{GlobalUtil.t("home_guide.create_wallet")}</div>
//                         <a
//                             href="https://chrome.google.com/webstore/detail/leo-wallet/nebnhfamliijlghikdgcigoebonmoibm?utm_source=app-launcher"
//                             target="_blank"
//                             style={{ marginTop: StyleUtils.getHeight(2) }} rel="noreferrer">
//                             Neptune {GlobalUtil.t("home_guide.wallet")}
//                         </a>
//                     </Card>
//                     </AntdCard>
//                 },
                {
                    children: <AntdCard><Card>
                        <div style={{ ...StyleUtils.fontStyle_2(), fontSize: StyleUtils.getFont(14) }}>{GlobalUtil.t("home_guide.download")}</div>
                        <div style={{ ...StyleUtils.fontStyle_3(), marginTop: StyleUtils.getHeight(5) }}>{GlobalUtil.t("home_guide.download_desc")}</div>
                        <Row style={{ marginTop: StyleUtils.getHeight(3), columnGap: ".5rem" }}>
                            <a href={GITHUB_LINKS[UserInfoManager.getCurrency() as keyof typeof GITHUB_LINKS] || GITHUB_LINKS.neptune} target="_blank">Miner</a>

                        </Row>
                    </Card>
                    </AntdCard>
                },
                {
                    children: <AntdCard><Card>
                        <div style={{ ...StyleUtils.fontStyle_2(), fontSize: StyleUtils.getFont(14) }}>{GlobalUtil.t("home_guide.input_data")}</div>
                        <div style={{ ...StyleUtils.fontStyle_3(), marginTop: StyleUtils.getHeight(5) }}>{GlobalUtil.t("home_guide.input_account_and_workername")} </div>
                        <div style={{ ...StyleUtils.fontStyle_3(), marginTop: StyleUtils.getHeight(5) }}>{GlobalUtil.t("home_guide.change_for_start_miner")}</div>
                        {/* <div style={{ ...StyleUtils.fontStyle_2(), marginTop: StyleUtils.getHeight(9) }}>{GlobalUtil.t("home_guide.example")}</div> */}
                        <div style={{ marginTop: StyleUtils.getHeight(3), display: "flex", }}>
                            <div style={{ display: "flex", width: '100%', gap: '1rem',flexFlow:'row wrap' }}>
                                {
                                    expInputs.flatMap((v, index) => {
                                        return <div key={v.title} style={{ flex: '1 1 33%',maxWidth:'26rem' }} >
                                            <InfoItemView title={v.title} text={v.value} onChange={handleExpInputs} />
                                        </div>
                                    })

                                }
                            </div>
                        </div>
                    </Card>
                    </AntdCard>
                },
                {
                    children: <AntdCard> <Card>
                        <div style={{ ...StyleUtils.fontStyle_2(), fontSize: StyleUtils.getFont(14) }}>{GlobalUtil.t("home_guide.start_miner")}</div>
                        <div style={{ ...StyleUtils.fontStyle_3(), marginTop: StyleUtils.getHeight(5) }}>{GlobalUtil.t("home_guide.start_miner_desc1")} sudo chmod +x {getCoinConfig(UserInfoManager.currency).prover}</div>
                        <div style={{ ...StyleUtils.fontStyle_3(), marginTop: StyleUtils.getHeight(5) }}>{GlobalUtil.t("home_guide.start_miner_desc2")}</div>
                        <div style={{ ...StyleUtils.fontStyle_2(), marginTop: StyleUtils.getHeight(9) }}>{GlobalUtil.t("home_guide.command_below")}</div>
                        <div style={{ marginTop: StyleUtils.getHeight(3), display: "flex", flexDirection: 'row' }}>
                            <div style={{ display: "flex", flexDirection: "column", width: xs ? "100%" : "80%" }}>
                                {
                                    Items2.flatMap((v, index) => {
                                        return <div key={v.title} style={{ marginTop: StyleUtils.getWidth(11), width: "100%" }} >
                                            <InfoItemView title={v.title} text={v.value} />
                                        </div>
                                    })
                                }
                            </div>
                        </div>

                        <div style={{ width: 'fit-content', marginTop: StyleUtils.getHeight(5) }}>
                            {/* <AppButton
                                style={{
                                    display: 'block'
                                }}
                                onClick={() => {
                                    setOpenHelp(true)
                                }}
                                text=" Miner Help" /> */}
                            <Link to="/help/guide" >{GlobalUtil.t("home_guide.miner_help")}</Link>
                        </div>

                    </Card>
                    </AntdCard>
                },
                ...(getCoinConfig(UserInfoManager.currency).dualMining ? [{
                    children: <AntdCard> <Card>
                        <div style={{ ...StyleUtils.fontStyle_2(), fontSize: StyleUtils.getFont(14) }}>{GlobalUtil.t("miner_help.how_to_dual_mining")}</div>
                        <div style={{ ...StyleUtils.fontStyle_3(), marginTop: StyleUtils.getHeight(5) }}>{GlobalUtil.t("miner_help.miner_detail_refer_to")} <Link to="https://github.com/0xdrpool/neptune_gpu_guesser/blob/main/Dual_Mining.md" target="_blank" style={{color: StyleUtils.theme().fontColor_1,textDecoration: 'underline'}}>Dual_Mining.md</Link> </div>
                    </Card>
                    </AntdCard>
                }] : [])
            ]}
        />
        {/* <MinerHelp open={true} onClose={handleCloseHelpDrawer} /> */}
    </div>
}